<template>
  <v-card-text class="py-6 px-6" v-if="group !== undefined">
    <p class="text-h6 font-weight-light white--text">
      <span class="dw_green--text mr-2">{{ group.mitre_id }}</span>
      {{ group.name }}
    </p>
    <p class="body-2 font-weight-light mb-0">
      {{ group.description }}
    </p>
  </v-card-text>
</template>

<script>
export default {
  name: 'groupDetails',
  props: ['group']
};
</script>
